<template>
  <div class="statistics">
    <div class="header-label">
      <el-button type="primary" @click="downloadProject()">{{$t('jobManagementV2.downloadReport')}}</el-button>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="" name="项目">
          <span slot="label">
            <span class="span-box">
              <span class="text">{{$t('project.project')}}</span>
              <span :class="activeName=='项目'? 'num' : 'gray'">{{tabNums.projectClassifyNum||0}}</span>
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="" name="任务">
          <span slot="label">
            <span class="span-box">
              <span class="text">{{$t('fileManagement.task')}}</span>
              <span :class="activeName=='任务'? 'num' : 'gray'">{{tabNums.countTaskModuleNum||0}}</span>
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="" name="翻译文件">
          <span slot="label">
            <span class="span-box">
              <span class="text">{{$t('fileManagement.translateFile')}}</span>
              <span :class="activeName=='翻译文件'? 'num' : 'gray'">{{tabNums.countTransCompleteNum||0}}</span>
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="" name="翻译记忆库">
          <span slot="label">
            <span class="span-box">
              <span class="text">{{$t('newProjectV2.transMemoryBank')}}</span>
              <span :class="activeName=='翻译记忆库'? 'num' : 'gray'">{{tabNums.countMemoryClassifyNum||0}}</span>
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane label="" name="术语库">
          <span slot="label">
            <span class="span-box">
              <span class="text">{{$t('term.termLib')}}</span>
              <span :class="activeName=='术语库'? 'num' : 'gray'">{{tabNums.countTermClassifyNum||0}}</span>
            </span>
          </span>
        </el-tab-pane>

      </el-tabs>
      <router-link v-show="item.value==tabName" v-for="(item,index) in toPath" :to="{name:item.name}" :key="index">
        <span class="skip">{{item.lable}} <span class="icon"></span></span>
      </router-link>

    </div>
    <div class="table">
      <project-table v-if="activeName=='项目'" />
      <task-table v-if="activeName=='任务'" />
      <file-table v-if="activeName=='翻译文件'" />
      <memory-table v-if="activeName=='翻译记忆库'" />
      <term-table v-if="activeName=='术语库' " />
    </div>
  </div>
</template>

<script>
import { headerData, downLoadFile, getDownloadAsyncResult } from "@/services/statistics"
import { apiRoot } from '@/services/ajax';
import projectTable from './modele/projectTable.vue'
import taskTable from './modele/taskTable.vue'
import fileTable from './modele/fileTable.vue'
import memoryTable from './modele/memoryTable.vue'
import termTable from './modele/termTable.vue'
export default {
  name: "statistics",
  components: {
    projectTable,
    taskTable,
    fileTable,
    memoryTable,
    termTable,
  },
  data() {
    return {
      activeName: "项目",
      toPath: [{
        value: '项目',
        lable: this.$t('fileManagement.myProject'),
        name: "fileList"
      }, {
        value: '任务',
        lable: this.$t('managementV2.myAssignment'),
        name: "myTask"
      }, {
        value: '翻译文件',
        lable: this.$t('fileManagement.myTranslationFile'),
        name: "fileManage",
      }, {
        value: '翻译记忆库',
        lable: this.$t('fileManagement.myTranslationMemory'),
        name: "memoryLib",
      }, {
        value: '术语库',
        lable: this.$t('fileManagement.myGlossary'),
        name: "termLib"
      }],
      tabName: "项目",
      tabNums: {}
    }
  },
  mounted() {
    this.getHeaderData()
  },
  methods: {
    async downloadProject() {
      let params = {
        userId: JSON.parse(localStorage.userInfo).id
      }
      const { success, result } = await downLoadFile(params)
      if (success) {
        this.getDownloadAsyncResult(result)
      }

    },
    async getDownloadAsyncResult(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode == "1") {
          // if (parseInt(result.percent) === 100) {
          //   clearInterval(setItem);
          //   setItem = null;
          //   this.isDownloadLoading = false;
          //   this.downloadServerFile(result.fileName, result.downloadUrl)
          // }
          clearInterval(setItem);
          setItem = null;
          this.downloadServerFile(result)
        }
        //  else {
        //   clearInterval(setItem);
        //   setItem = null;
        //   this.isDownloadLoading = false;
        // }
      }, 2000);
    },
    // a链接下载
    downloadServerFile(filePath) {
      let link = document.createElement("a");
      link.style.display = "none";

      let fileName = '统计列表.xlsx'

      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      this.downloadFileName = '';
      document.body.appendChild(link);
      link.click();
    },
    //获取头部数据
    async getHeaderData() {
      let params = {
        userId: JSON.parse(localStorage.userInfo).id
      }
      const { success, result } = await headerData(params)
      if (success) {
        this.tabNums = result
      }
    },
    handleClick(tab, event) {
      this.tabName = tab.name
    }
  },
}
</script>

<style lang="less" scoped>
.statistics {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  padding: 15px;
  .header-label {
    position: relative;
    text-align: left;
    .el-button {
      font-size: 14px;
      padding: 0 15px;
      height: 32px;
    }

    /deep/ .el-tabs {
      margin-top: 10px;
      .el-tabs__nav-wrap::after {
      
        background-color: #efefef;
      
      }
      .span-box {
        display: flex;
        align-items: center;
        .text {
          font-weight: bold;
        }
        .num {
          width: 40px;
          margin-left: 12px;
          line-height: 20px;
          text-align: center;
          font-size: 12px;

          height: 20px;
          background: #0078fc;
          border-radius: 4px;
          color: #fff;
        }
        .gray {
          width: 40px;
          margin-left: 12px;
          line-height: 20px;
          text-align: center;
          font-size: 12px;
          height: 20px;
          background: #0078fc;
          border-radius: 4px;
          background: #e5e7eb;
          color: #666666;
        }
      }
    }
    .skip {
      cursor: pointer;
      font-size: 14px;
      display: inline-block;
      position: absolute;
      top: 50px;
      right: 0;
      color: #9ca9bd;
      .icon {
        width: 10px;
        height: 10px;
        display: inline-block;

        background: url("./assets/images/text.png") no-repeat center;
      }
    }
  }
  .table {
    width: 100%;
    height: calc(100% - 77px);
  }
}
</style>